import type { MapTileLayer } from "./utils/types";

export const MAX_POINTS_FOR_UI = 2000;
export const MAX_CHART_POINTS = 2000;

export const DEFAULT_DELAY_OFFSET_MS = 200;

export const REALTIME_RIGHT_EDGE_FALLBACK_LAG_MS = 3000;

export const DEFAULT_FOLLOW_MAP = false;
export const DEFAULT_SHOW_VIDEO = true;

export const DEFAULT_MAP_TILE_LAYER: MapTileLayer = "osm";
